import * as React from 'react';
export const transferSvg = React.forwardRef(function transferSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.2 4.74a.75.75 0 0 0 1.1 1.02l1.95-2.1v10.59a.75.75 0 0 0 1.5 0V3.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L8.2 4.74Zm-3.45 7.6 1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L.2 11.26a.747.747 0 0 1 .04-1.06.75.75 0 0 1 1.06.04l1.95 2.1V1.75a.75.75 0 0 1 1.5 0v10.59Z',
    }),
  );
});
transferSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var transfer = {
  category: 'icon',
  colorable: true,
  name: 'transfer',
  svg: transferSvg,
};
